import { v1 } from "../api";

export async function createSolicitud({ empresa = {}, files = [] }) {
  const formData = new FormData();

  formData.append("empresa", JSON.stringify(empresa));

  for (const file of files) {
    formData.append(file.name, file);
  }

  const response = await v1.post("solicitudes", formData, {
    responseType: "blob",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return new Blob([response.data], { type: "application/pdf" });
}
